(function () {
  if (window.UlCampaignPages) return;

  const moneyFormatter = (currency) => new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency || 'USD'
  });

  const initCountdown = (root) => {
    const countdown = root.querySelector('[data-ucp-countdown]');
    if (!countdown || countdown.dataset.initialized === 'true') return;

    const endTime = Date.parse(countdown.dataset.end || '');
    if (Number.isNaN(endTime)) {
      countdown.textContent = countdown.dataset.invalidLabel || '';
      return;
    }

    countdown.dataset.initialized = 'true';
    const update = () => {
      const remaining = endTime - Date.now();
      if (remaining <= 0) {
        countdown.textContent = countdown.dataset.endedLabel || 'Offer ended';
        return;
      }

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      countdown.textContent = `${days}d ${hours}h ${minutes}m`;
    };

    update();
    countdown.ucpInterval = window.setInterval(update, 60000);
  };

  const initBuilder = (root) => {
    const builder = root.querySelector('[data-ucp-builder]');
    if (!builder || builder.dataset.initialized === 'true') return;

    const rows = Array.from(builder.querySelectorAll('[data-ucp-product]'));
    if (!rows.length) return;

    builder.dataset.initialized = 'true';
    const products = rows.map((row) => ({
      row,
      key: row.dataset.productKey,
      variantId: Number.parseInt(row.dataset.variantId || '0', 10),
      available: row.dataset.available === 'true',
      price: Number.parseInt(row.dataset.price || '0', 10),
      quantity: 0,
      output: row.querySelector('[data-ucp-quantity]')
    }));
    const presets = Array.from(builder.querySelectorAll('[data-ucp-preset]'));
    const addButton = builder.querySelector('[data-ucp-add-to-cart]');
    const buttonLabel = addButton ? addButton.querySelector('[data-ucp-button-label]') : null;
    const cartStatus = builder.querySelector('[data-ucp-cart-status]');
    const formatter = moneyFormatter(builder.dataset.currency);
    let submitting = false;
    const tierDiscounts = [
      0,
      Number.parseInt(builder.dataset.tier1 || '12', 10),
      Number.parseInt(builder.dataset.tier2 || '15', 10),
      Number.parseInt(builder.dataset.tier3 || '30', 10)
    ];

    const tierFor = (count) => {
      if (count >= 3) return tierDiscounts[3];
      return tierDiscounts[count] || 0;
    };

    const formatCents = (cents) => formatter.format(cents / 100);
    const setStatus = (message, state = '') => {
      if (!cartStatus) return;
      cartStatus.textContent = message;
      cartStatus.hidden = !message;
      cartStatus.dataset.state = state;
    };

    const update = () => {
      const count = products.reduce((sum, item) => sum + item.quantity, 0);
      const discount = tierFor(count);
      const listTotal = products.reduce((sum, item) => sum + item.price * item.quantity, 0);
      const eventTotal = products.reduce((sum, item) => {
        const discountedUnit = item.price - Math.floor(item.price * discount / 100);
        return sum + discountedUnit * item.quantity;
      }, 0);

      products.forEach((item) => {
        if (item.output) item.output.textContent = String(item.quantity);
        item.row.querySelectorAll('[data-ucp-action]').forEach((control) => {
          control.disabled = submitting || !item.available;
        });
      });
      presets.forEach((preset) => { preset.disabled = submitting; });
      builder.querySelector('[data-ucp-lock-count]').textContent = String(count);
      builder.querySelector('[data-ucp-discount]').textContent = count ? `${discount}% off` : builder.dataset.emptyDiscount;
      builder.querySelector('[data-ucp-savings]').textContent = formatCents(listTotal - eventTotal);
      builder.querySelector('[data-ucp-total]').textContent = formatCents(eventTotal);
      builder.querySelector('[data-ucp-tier-message]').textContent = count
        ? `${discount}% applies to all ${count} eligible lock${count === 1 ? '' : 's'}.`
        : builder.dataset.emptyMessage;

      if (addButton) {
        const disabled = submitting || count === 0;
        addButton.disabled = disabled;
        addButton.setAttribute('aria-disabled', String(disabled));
        addButton.setAttribute('aria-busy', String(submitting));
        if (buttonLabel) {
          buttonLabel.textContent = submitting
            ? addButton.dataset.loadingLabel
            : addButton.dataset.defaultLabel;
        }
      }
    };

    const publishCartUpdate = (cart) => {
      if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'campaign-product-builder',
          cart
        });
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'campaign-product-builder',
          cart
        });
      }
    };

    const addSelectionToCart = async () => {
      if (submitting || !addButton) return;

      const selected = products.filter((item) => item.quantity > 0);
      if (!selected.length) return;
      if (selected.some((item) => !item.available || !item.variantId)) {
        setStatus(builder.dataset.cartError, 'error');
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer');
      const sections = [];
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        cartDrawer.getSectionsToRender().forEach((section) => sections.push(section.id));
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
        bubbles: true,
        detail: { sections }
      }));

      const cartAddUrl = (window.theme && theme.routes && theme.routes.cart_add_url)
        || (window.routes && window.routes.cart_add_url)
        || '/cart/add.js';
      const cartUrl = (window.theme && theme.routes && theme.routes.cart_url)
        || (window.routes && window.routes.cart_url)
        || '/cart';
      const body = JSON.stringify({
        items: selected.map((item) => ({ id: item.variantId, quantity: item.quantity })),
        sections: Array.from(new Set(sections)),
        sections_url: window.location.pathname
      });

      submitting = true;
      setStatus('', '');
      update();

      try {
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body
        });
        const parsedState = await response.json();
        if (!response.ok || parsedState.status) {
          throw new Error(parsedState.description || parsedState.message || builder.dataset.cartError);
        }

        let cart = null;
        try {
          const cartJsonUrl = /\.js(?:\?|$)/.test(cartUrl)
            ? cartUrl
            : `${cartUrl.replace(/\/$/, '')}.js`;
          const cartResponse = await fetch(cartJsonUrl, {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          });
          if (cartResponse.ok) cart = await cartResponse.json();
        } catch (cartError) {
          console.warn('Campaign builder could not refresh cart JSON.', cartError);
        }
        if (cart && parsedState.sections) cart.sections = parsedState.sections;
        publishCartUpdate(cart);

        if (cartDrawer && parsedState.sections && typeof cartDrawer.renderContents === 'function') {
          if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(addButton);
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(parsedState);
        } else if (cartDrawer && typeof cartDrawer.show === 'function') {
          cartDrawer.show(addButton);
        } else if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open(addButton);
        } else {
          document.querySelector('#cart-icon-bubble')?.click();
        }

        products.forEach((item) => { item.quantity = 0; });
        presets.forEach((preset) => preset.classList.remove('is-active'));
        setStatus(builder.dataset.cartSuccess, 'success');
      } catch (error) {
        setStatus(error.message || builder.dataset.cartError, 'error');
      } finally {
        submitting = false;
        update();
      }
    };

    builder.addEventListener('click', (event) => {
      const stepButton = event.target.closest('[data-ucp-action]');
      if (stepButton && builder.contains(stepButton)) {
        const product = products.find((item) => item.key === stepButton.dataset.productKey);
        if (!product || !product.available || submitting) return;
        setStatus('', '');
        product.quantity = stepButton.dataset.ucpAction === 'plus'
          ? Math.min(product.quantity + 1, 9)
          : Math.max(product.quantity - 1, 0);
        presets.forEach((preset) => preset.classList.remove('is-active'));
        update();
        return;
      }

      const cartButton = event.target.closest('[data-ucp-add-to-cart]');
      if (cartButton && builder.contains(cartButton)) {
        addSelectionToCart();
        return;
      }

      const presetButton = event.target.closest('[data-ucp-preset]');
      if (!presetButton || !builder.contains(presetButton) || submitting) return;
      setStatus('', '');
      const quantities = (presetButton.dataset.quantities || '').split(',').map((value) => Number.parseInt(value, 10) || 0);
      products.forEach((product, index) => {
        product.quantity = product.available ? Math.min(quantities[index] || 0, 9) : 0;
      });
      presets.forEach((preset) => preset.classList.toggle('is-active', preset === presetButton));
      update();
      const tool = builder.querySelector('.ucp-builder');
      if (tool) tool.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center'
      });
    });

    update();
  };

  const init = (scope) => {
    const root = scope || document;
    root.querySelectorAll('.ucp').forEach((section) => {
      initCountdown(section);
      initBuilder(section);
    });
  };

  window.UlCampaignPages = { init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
